// src/components/Fields/MultiLineTextPreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';
import DraggablePreviewWrapper from './DraggablePreviewWrapper';  // Ensure the path is correct
import { useFormLayout } from '../../contexts/FormLayoutContext'; // Adjust path as necessary

const MultiLineTextPreview = ({ id, index }) => {
    const { showDropZones, setShowDropZones } = useFormLayout();  // Use context to manage showDropZones

    return (
        <DraggablePreviewWrapper
            id={id}
            type="multi-line-text" // Matches the type expected in FieldRenderer
            index={index}
            isNew={true}
            showDropZones={showDropZones} // Pass down showDropZones state
            setShowDropZones={setShowDropZones} // Pass down setShowDropZones function
        >
            <Box display="flex" alignItems="center">
                <NotesIcon sx={{ fontSize: '0.95rem', marginRight: '8px', color: '#455A64' }} />
                <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}>
                    Multi-line Text
                </Typography>
            </Box>
        </DraggablePreviewWrapper>
    );
};

export default MultiLineTextPreview;
